import React, { memo, useState } from "react";
import './QuizProgress.css';

const THEME_PAIRS = [
  { runner: '🚀', target: '🌕', name: 'Space Explorer', runnerClass: 'rotate-45' },
  { runner: '🐭', target: '🧀', name: 'Mouse & Cheese' },
  { runner: '🐱', target: '🐟', name: 'Cat & Fish' },
  { runner: '🐶', target: '🦴', name: 'Dog & Bone' },
  { runner: '🐰', target: '🥕', name: 'Bunny & Carrot' },
  { runner: '🐝', target: '🌻', name: 'Bee & Sunflower', runnerClass: 'flip-x' },
  { runner: '🐒', target: '🍌', name: 'Monkey & Banana', runnerClass: 'flip-x' },
  { runner: '🏎️', target: '🏁', name: 'Race Car & Finish Line', runnerClass: 'flip-x' },
  { runner: '🏃', target: '🏆', name: 'Runner & Trophy', runnerClass: 'flip-x' },
  { runner: '🐸', target: '🪷', name: 'Frog & Lilypad' },
  { runner: '🐻', target: '🍯', name: 'Bear & Honey', runnerClass: 'flip-x' },
  { runner: '🐼', target: '🎋', name: 'Panda & Bamboo', runnerClass: 'flip-x' },
  { runner: '🐿️', target: '🌰', name: 'Squirrel & Acorn', runnerClass: 'flip-x' },
  { runner: '🐧', target: '🧊', name: 'Penguin & Iceberg', runnerClass: 'flip-x' },
  { runner: '🦋', target: '🌸', name: 'Butterfly & Cherry Blossom', runnerClass: 'flip-x' },
  { runner: '🧙‍♂️', target: '✨', name: 'Wizard & Magic', runnerClass: 'flip-x' },
  { runner: '🏴‍☠️', target: '💎', name: 'Pirate & Treasure', runnerClass: 'flip-x' },
  { runner: '🦖', target: '🌋', name: 'Dino & Volcano', runnerClass: 'flip-x' },
  { runner: '🦄', target: '🌈', name: 'Unicorn & Rainbow', runnerClass: 'flip-x' },
  { runner: '🛸', target: '🪐', name: 'UFO & Saturn' },
  { runner: '🚂', target: '🚉', name: 'Train & Station', runnerClass: 'flip-x' },
  { runner: '⛵', target: '🏝️', name: 'Sailboat & Tropical Island', runnerClass: 'flip-x' },
  { runner: '🚴', target: '🏕️', name: 'Bicycle & Campsite', runnerClass: 'flip-x' },
  { runner: '🚁', target: '⛰️', name: 'Helicopter & Mountain Peak', runnerClass: 'flip-x' },
  { runner: '🧸', target: '🛏️', name: 'Teddy Bear & Bedtime', runnerClass: 'flip-x' },
  { runner: '🍪', target: '🥛', name: 'Cookie & Milk' },
  { runner: '🐥', target: '🌾', name: 'Chick & Wheat', runnerClass: 'flip-x' },
  { runner: '🐙', target: '🐚', name: 'Octopus & Seashell' },
  { runner: '🚜', target: '🌾', name: 'Tractor & Harvest', runnerClass: 'flip-x' },
  { runner: '⚽', target: '🥅', name: 'Soccer Ball & Goal Net' },
];

const QuizProgress = ({ currentIndex, questionsCount }) => {
  const [theme] = useState(() => {
    const randomIndex = Math.floor(Math.random() * THEME_PAIRS.length);
    return THEME_PAIRS[randomIndex];
  });

  const progressRatio = questionsCount > 0 ? (currentIndex + 1) / questionsCount : 0;
  const percentage = Math.min(100, Math.max(0, progressRatio * 100));

  // Scales smoothly between 0.95 and 1.25 as progress advances
  const targetScale = 0.95 + progressRatio * 0.3;

  return (
    <div className="quiz-progress-container">
      <div className="quiz-progress-wrapper">
        <div
          className="progress-fill"
          style={{ width: `${percentage}%` }}
        >
          {/* Runner Circular Badge */}
          <div className="progress-runner" aria-label={theme.name}>
            <span
              className={`runner-emoji ${theme.runnerClass || ''}`}
              role="img"
              aria-hidden="true"
            >
              {theme.runner}
            </span>
          </div>
        </div>
      </div>

      {/* Target Circular Badge */}
      <div
        className="progress-target-badge"
        style={{ transform: `scale(${targetScale})` }}
        aria-label="Goal"
      >
        <span className="target-emoji" role="img" aria-hidden="true">
          {theme.target}
        </span>
      </div>
    </div>
  );
};

export default memo(QuizProgress);